// frontend/src/pages/public/LegalIndex.jsx
import React from "react";
import { Link } from "react-router-dom";
import Seo from "../../marketing/Seo";
import { LEGAL_DOCS } from "../../marketing/data/legal";

const EXTRA = [
  { to: "/legal/privacy", title: "Privacy Policy", description: "How QRFlow collects, uses, retains, and protects your data." },
  { to: "/security", title: "Security", description: "Our privacy-first security posture and practices." },
];

export default function LegalIndex() {
  const items = [
    ...LEGAL_DOCS.map((d) => ({ to: `/legal/${d.slug}`, title: d.title, description: d.description })),
    ...EXTRA,
  ];

  return (
    <>
      <Seo
        title="Legal"
        description="QRFlow legal centre — terms, privacy, cookies, acceptable use, DPA, subprocessors, and billing."
        path="/legal"
      />
      <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Legal centre</h1>
      <p className="mt-4 max-w-2xl text-lg text-gray-600">
        The policies and agreements that govern your use of QRFlow.
      </p>
      <div className="mt-10 grid gap-5 sm:grid-cols-2">
        {items.map((d) => (
          <Link
            key={d.to}
            to={d.to}
            className="rounded-2xl border border-gray-200 p-6 transition hover:border-brand-300 hover:shadow-sm"
          >
            <h2 className="text-lg font-semibold text-gray-900">{d.title}</h2>
            <p className="mt-2 text-sm leading-6 text-gray-600">{d.description}</p>
          </Link>
        ))}
      </div>
    </>
  );
}
